import React from 'react';

export default function Polices() {
    return <div>Polices</div>;
}
